var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoNewRows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Infomation_-_new_rows",
    "data-name": "Infomation - new rows",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.284,
    height: 13.284,
    viewBox: "0 0 13.284 13.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13440",
    "data-name": "Path 13440",
    d: "M17.284,10.642A6.642,6.642,0,1,1,10.642,4,6.642,6.642,0,0,1,17.284,10.642Z",
    transform: "translate(-4 -4)",
    fill: "#6690FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13441",
    "data-name": "Path 13441",
    d: "M21.666,16.657h1.328V20.31H21.666ZM23.16,14.83a.83.83,0,1,1-.83-.83A.831.831,0,0,1,23.16,14.83Z",
    transform: "translate(-15.688 -10.679)",
    fill: "#D6E4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNewRows);
export default __webpack_public_path__ + "static/media/info-new-rows.931a66ec44f98111e4ae2eabb4cce246.svg";
export { ForwardRef as ReactComponent };